import React from "react";
import { Route, Redirect } from "react-router-dom";
import { connect } from "react-redux";

function ProtectedRoute({ component: Component, currentUserStatus, ...restOfProps }) {
    const isAuthenticated = currentUserStatus && currentUserStatus.response && currentUserStatus.response.enabled;
    return (
        <Route
            {...restOfProps}
            render={(props) =>
                isAuthenticated ? (
                    <React.Fragment>
                        <Component {...props} />{" "}
                    </React.Fragment>
                ) : (
                    <Redirect to="/dashboard" />
                )
            }
        />
    );
}
export default connect((state) => ({
    currentUserStatus: state.getCurrentUserStatus,
}))(ProtectedRoute);
